export default "__VITE_ASSET__Dx0ABJ6p__"